export const ldapConfigForm = {
    button: {
        save: 'Save',
        import: 'Import',
    },
    title: {
        serverUrl: 'Ldap server url',
        baseUsersDn: 'Base users distinguished name',
        adminDn: 'Admin distinguished name',
        adminPassword: 'Admin password',
        country: 'Country',
        ldapConfig: 'LDAP Server Config',
        ldapUserList: 'LDAP User List',
    },
    placeholder: {
        serverUrl: 'Enter LDAP server url',
        baseUsersDn: 'Enter base users',
        adminDn: 'Enter admin distinguished name',
        adminPassword: 'Enter admin password',
        country: 'Select country',
    },
    message: {
        saveSuccess: 'Setting LDAP server successfully',
    },
    ldapUserList: {
        email: 'Email',
        username: 'Username',
    },
};
